<script lang="ts">
  import Router, { push, querystring } from "svelte-spa-router";
  import { wrap } from "svelte-spa-router/wrap";
  import Home from "./Home.svelte";
  import TeamApps from "./team/TeamApps.svelte";
  import Members from "./team/Members.svelte";
  import Profile from "./Profile.svelte";
  import OrgOverview from "./orgs/OrgOverview.svelte";
  import UserSidebar from "$lib/components/layout/UserSidebar.svelte";
  import TeamOverview from "./team/TeamOverview.svelte";
  import Index from "./orgs/Index.svelte";
  import OrgPermissionAssurance from "./orgs/OrgPermissionAssurance.svelte";
  import OrgMembers from "./orgs/OrgMembers.svelte";
  import Start from "./setup/onboarding/Start.svelte";
  import Review from "./setup/onboarding/Review.svelte";
  import ConnectData from "./setup/onboarding/ConnectData.svelte";
  import ConnectSso from "./setup/onboarding/ConnectSso.svelte";
  import DemoOverview from "./setup/OrgOverviewDemo.svelte";
  import { DrawerContent, Root as DrawerRoot } from "$ui/drawer";
  import PageNotFound from "./PageNotFound.svelte";
  import OrgPISIDetection from "./orgs/OrgPISIDetection.svelte";
  import OrgExposedSensitiveDocuments from "./orgs/OrgExposedSensitiveDocuments.svelte";
  import OrgCustomInfoTypes from "./orgs/OrgCustomInfoTypes.svelte";
  import { sidebar } from "$lib/stores/sidebar.svelte";

  import { location } from "svelte-spa-router";
  import MainToolbar from "$lib/components/layout/MainToolbar.svelte";

  const authedRoutes = {
    // --------- Profile Routes ---------
    "/profile": wrap({
      component: Profile,
    }),

    // --------- Home Routes ---------
    "/": wrap({
      component: Home,
    }),

    // --------- Team Routes ---------
    "/t/:teamId": wrap({
      component: TeamOverview,
    }),
    "/t/:teamId/": wrap({
      component: TeamOverview,
    }),
    "/t/:teamId/apps": wrap({
      component: TeamApps,
    }),
    "/t/:teamId/members": wrap({
      component: Members,
    }),

    // --------- Organization Routes ---------
    "/o/:orgId": wrap({
      component: OrgOverview,
    }),
    "/o/:orgId/": wrap({
      component: OrgOverview,
    }),
    "/o/:orgId/members/": wrap({
      component: OrgMembers,
    }),
    "/o/:orgId/index": wrap({
      component: Index,
    }),
    "/o/:orgId/settings/": wrap({
      component: Review,
    }),
    "/o/:orgId/review": wrap({
      component: Review,
    }),

    // --------- Organization Security Routes ---------
    "/o/:orgId/security/permissions-assurance": wrap({
      component: OrgPermissionAssurance,
    }),
    "/o/:orgId/security/permissions-assurance/": wrap({
      component: OrgPermissionAssurance,
    }),
    "/o/:orgId/security/permissions-assurance/:finding": wrap({
      component: OrgPermissionAssurance,
    }),
    "/o/:orgId/security/permissions-assurance/:finding/": wrap({
      component: OrgPermissionAssurance,
    }),
    "/o/:orgId/security/sensitive-data-detection": wrap({
      component: OrgPISIDetection,
    }),
    "/o/:orgId/security/sensitive-data-detection/": wrap({
      component: OrgPISIDetection,
    }),
    "/o/:orgId/security/exposed-sensitive-documents": wrap({
      component: OrgExposedSensitiveDocuments,
    }),
    "/o/:orgId/security/exposed-sensitive-documents/": wrap({
      component: OrgExposedSensitiveDocuments,
    }),
    "/o/:orgId/settings/custom-info-types": wrap({
      component: OrgCustomInfoTypes,
    }),
    "/o/:orgId/settings/custom-info-types/": wrap({
      component: OrgCustomInfoTypes,
    }),

    // --------- Organization Integration Routes ---------
    "/o/:orgId/connect_sso": wrap({
      component: ConnectSso,
    }),
    "/o/:orgId/connect_data": wrap({
      component: ConnectData,
    }),

    // --------- Onboarding Routes ---------
    "/overview": wrap({
      component: DemoOverview,
    }),
    "/onboarding": wrap({
      component: Start,
    }),
    "/onboarding/": wrap({
      component: Start,
    }),
    "/onboarding/connect_sso": wrap({
      component: ConnectSso,
    }),
    "/onboarding/connect_data": wrap({
      component: ConnectData,
    }),
    "/onboarding/review": wrap({
      component: Review,
    }),

    // --------- Demo Security Routes ---------
    "/security/permissions-assurance": wrap({
      component: OrgPermissionAssurance,
      props: {
        mock: true,
      },
    }),
    "/security/sensitive-data-detection": wrap({
      component: OrgPISIDetection,
      props: {
        mock: true,
      },
    }),

    // --------- 404 Route ---------
    "*": PageNotFound,
  };
</script>

<div class="flex flex-col lg:flex-row relative flex-grow">
  <UserSidebar />
  <!-- px-6 lg:px-10 py-5 sm:py-8 lg:py-10  -->
  <main class="flex-1 flex flex-col">
    <MainToolbar />
    <Router routes={authedRoutes} on:routeLoading={console.debug} on:routeLoaded={console.debug} />
  </main>
  <DrawerRoot
    bind:open={sidebar.snippet}
    preventScroll={false}
    closeFocus={null}
    onOpenChange={(isOpen) => {
      // when closing update the route to remove the query string
      // if (!isOpen) sidebar.snippet = null;
      if (!isOpen) push($location);
    }}
  >
    <DrawerContent>
      {@render sidebar.snippet?.()}
    </DrawerContent>
  </DrawerRoot>
</div>
